/*
  Shift · Cart reassurance (snippets/sr-cart-reassurance.liquid)
  The cart box carries Affirm's line with the cart total already in it. Each time the
  cart drawer is drawn (page load, add to cart, quantity change), this asks affirm.js
  to fill it straight away, rather than waiting for the Affirm app embed's 1.1 s timer.
  affirm.js comes from that embed; without it (outside the US) the line stays empty
  and its row hidden. A US row that holds its space for Affirm (snippet) but is never
  filled, say Affirm is blocked, is dropped after a few seconds.
  Affirm empties a line and draws it again each time it refreshes (35-100 ms blank). Every
  line it has drawn with a monthly price is remembered by amount, and put straight back when
  Affirm empties a line with that amount, or writes its general no-price message because a
  request failed. Affirm's fresh line then replaces it. Covers the buy box too, and the first
  cart total, which is the buy box's price.
  A new total (quantity change, remove, add to cart with a full cart) is worked out the moment
  it's asked for and drawn by Affirm off-screen while the cart updates; when the drawer redraws,
  that drawn line moves into the cart, so the amount is fetched once.
  Safe to include more than once: it starts once.
*/
(function () {
  if (window.SRCartReassure) return;
  window.SRCartReassure = true;

  var queued = false;
  var GIVE_UP_MS = 6000;

  // Remember which reserved rows Affirm has filled; give up on one that stays empty
  function watchReserved() {
    document.querySelectorAll('.sr-cart-reassure__row--reserved:not([data-sr-affirm-filled])').forEach(function (row) {
      var line = row.querySelector('.affirm-as-low-as');
      if (line && line.textContent.trim()) {
        row.setAttribute('data-sr-affirm-filled', '');
        row.removeAttribute('data-sr-affirm-failed');
        return;
      }
      if (row.__srGiveUp) return;
      row.__srGiveUp = setTimeout(function () {
        if (!row.hasAttribute('data-sr-affirm-filled')) row.setAttribute('data-sr-affirm-failed', '');
      }, GIVE_UP_MS);
    });
  }

  function fill() {
    queued = false;
    watchReserved();
    if (!window.affirm || !window.affirm.ui) return;
    // Empty, or showing a remembered copy (keepDrawn): either way Affirm draws it fresh
    var line = document.querySelector('.sr-cart-reassure__affirm .affirm-as-low-as:not([data-sr-asked])');
    if (!line) return;
    // Its amount is being drawn off-screen already: that line moves in when ready (adoptPrefetched),
    // so asking now would only fetch the same amount twice
    var waiting = holder && holder.querySelector('.affirm-as-low-as');
    if (waiting && waiting.getAttribute('data-amount') === line.getAttribute('data-amount')) return;
    // Asked once per drawn line, so a line Affirm leaves empty (an amount it won't offer) isn't asked again and again
    line.setAttribute('data-sr-asked', '');
    window.affirm.ui.ready(function () { window.affirm.ui.refresh(); });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(fill);
  }

  // Amount (cents) -> Affirm's last drawn markup for it
  var drawn = {};

  // A line with a monthly price. When its request fails, Affirm writes a general
  // "Pay over time… See if you qualify at checkout." with no price in it instead.
  function hasPrice(line) {
    return !!line.querySelector('.affirm-ala-price');
  }

  // Runs as a mutation callback, so before the next paint: a blank line never reaches the screen
  function keepDrawn() {
    document.querySelectorAll('.affirm-as-low-as[data-amount]').forEach(function (line) {
      var amount = line.getAttribute('data-amount');
      if (hasPrice(line)) drawn[amount] = line.innerHTML;
      // Empty, or the general message after a failed request: show the price Affirm gave for this amount before
      else if (drawn[amount]) line.innerHTML = drawn[amount];
    });
    adoptPrefetched();
  }

  // Move the line Affirm drew off-screen into the cart in place of the new one. Affirm knows
  // the moved line, so its later refreshes don't fetch that amount again; a fresh copy would be.
  function adoptPrefetched() {
    var ready = holder && holder.querySelector('.affirm-as-low-as');
    if (!ready || !hasPrice(ready)) return;
    var amount = ready.getAttribute('data-amount');
    var line = document.querySelector('.sr-cart-reassure__affirm .affirm-as-low-as[data-amount="' + amount + '"]');
    if (!line) return;
    ready.setAttribute('data-sr-asked', '');
    line.replaceWith(ready);
  }

  // Draw Affirm's line for an amount off-screen, so keepDrawn remembers it before the drawer needs it
  var holder = null;
  function prefetch(amount) {
    amount = Math.round(amount);
    if (!(amount > 0) || drawn[amount] || !window.affirm || !window.affirm.ui) return;
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'sr-affirm-prefetch';
      holder.setAttribute('aria-hidden', 'true');
      holder.inert = true;
      document.body.appendChild(holder);
    }
    holder.innerHTML = '<p class="affirm-as-low-as" data-page-type="cart" data-affirm-type="logo" data-affirm-color="blue" data-amount="' + amount + '"></p>';
    window.affirm.ui.ready(function () { window.affirm.ui.refresh(); });
  }

  function cartPrices() {
    var el = document.querySelector('#CartDrawer [data-sr-cart-prices]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // The total once line `index` (1-based, as the drawer numbers them) has `qty`
  function totalWith(index, qty) {
    var prices = cartPrices();
    var line = prices && prices.lines[index - 1];
    if (!line || isNaN(qty)) return 0;
    return prices.total - line.line + line.price * qty;
  }

  function onQuantity(event) {
    var input = event.target;
    if (!input.matches || !input.matches('#CartDrawer .quantity__input')) return;
    prefetch(totalWith(Number(input.dataset.index), parseInt(input.value, 10)));
  }

  function onClick(event) {
    var remove = event.target.closest && event.target.closest('#CartDrawer cart-remove-button');
    if (remove) {
      prefetch(totalWith(Number(remove.dataset.index), 0));
      return;
    }
    var add = event.target.closest && event.target.closest('.sr-bb button[name="add"]');
    if (add) {
      // The buy box's Affirm line carries the picked variant's price
      var variant = document.querySelector('.sr-bb__affirm .affirm-as-low-as');
      var price = variant ? Number(variant.getAttribute('data-amount')) : 0;
      var prices = cartPrices();
      if (price) prefetch((prices ? prices.total : 0) + price);
    }
  }

  function start() {
    keepDrawn();
    document.addEventListener('change', onQuantity, true);
    document.addEventListener('click', onClick, true);
    new MutationObserver(keepDrawn).observe(document.documentElement, { childList: true, subtree: true });
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (drawer) new MutationObserver(queue).observe(drawer, { childList: true, subtree: true });
    fill();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
